import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import FavStarFillIcon from '@wix/da-ds/pkg/Icons/24x24/FavStarFill';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import useDeviationStats from '../useDeviationStats';
import Stat from '../Stat';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
const FaveStat = ({ deviation, onlyNumbers, className, withUserList, showFavouritedByModal })=>{
    const { t } = useTranslation();
    const { faves, isFavouritable } = useDeviationStats(deviation);
    const openFavouritedModal = useCallback(()=>{
        yieldToMain(()=>{
            faves > 0 && showFavouritedByModal(deviation);
        });
    }, [
        faves,
        showFavouritedByModal,
        deviation
    ]);
    return !isFavouritable ? null : /*#__PURE__*/ React.createElement(Stat, {
        className: className,
        deviation: deviation,
        icon: FavStarFillIcon,
        statNameLocaleKey: "deviation.stats.faves",
        statCount: faves,
        onlyNumbers: onlyNumbers,
        userListType: withUserList ? 'favourite' : undefined,
        onClick: openFavouritedModal,
        title: t('deviation.stats.tooltip.faves'),
        biData: BiData({
            evid: 2,
            click_info: 'favourites',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        })
    });
};
FaveStat.displayName = 'FaveStat';
export default FaveStat;

//# sourceMappingURL=FaveStat.js.map